<template>
    <div class="comma">
        <span v-for="row in diff">{{ row.t }}</span>
    </div>
</template>

<script>
    export default {
      name: "DetailLevelS",
        props: {
            diff: { type: Array, required: true }
        },
    }
</script>
